module.exports = __webpack_public_path__ + "static/media/CinemaGrapAreasPractica new (1).818b16e2.mp4";